export { default as FeedbackCollector } from './feedback-collector';
